export class Form1095Model {
    form1095Items: Form1095Item[];

    constructor() {
        this.form1095Items = new Array<Form1095Item>();
    }
}

export class Form1095Item {
    form1095ID: number;
    fileName: string;
    linkText: string;
    fileType: string;
    createdOn: string;
    year: number;


    constructor() {
        this.form1095ID = 0;
        this.fileName = null;
        this.linkText = null;
        this.fileType = null;
        this.createdOn = null;
        this.year = 0;

    }
}

export class Form1095EmailCriteria {
    toAddress: string;
    form1095ID: number;
    constructor() {
        this.form1095ID = 0;
        this.toAddress = null;
    }
}